<div class="general-command-bar">
    @if (folderCreationRight && viewsStateService.getSelectedView().isArchive === false) {
        <button
            mat-fab
            class="basic-button small"
            aria-label="Créer un nouveau dossier"
            tabindex="5"
            matTooltip="Créer un nouveau dossier"
            matTooltipPosition="below"
            (click)="onCreateFolder()">
            <fa-icon [icon]="addFolderIcon"></fa-icon>
        </button>
    }
    <button mat-fab class="basic-button small" aria-label="Rafrichir la liste" tabindex="6" matTooltip="Rafrichir la liste" matTooltipPosition="below" (click)="onRefresh()">
        <fa-icon [icon]="refreshIcon"></fa-icon>
    </button>
    @if (archiveConsultattionRight) {
        @if (viewsStateService.getSelectedView().isArchive) {
            <button
                mat-fab
                class="basic-button small"
                aria-label="Accéder aux dossiers courants"
                tabindex="7"
                matTooltip="Accéder aux dossiers courants"
                matTooltipPosition="below"
                (click)="onSwitchBetweenArchivedAndLiveFoldersList()">
                <fa-icon [icon]="liveFoldersAccessIcon"></fa-icon>
            </button>
        } @else {
            <div class="archive-button-container" matTooltip="{{ view.archivingEnabled ? 'Accéder aux archives' : 'L\'archivage n\'est pas activé' }}" matTooltipPosition="below">
                <button
                    mat-fab
                    class="basic-button small"
                    aria-label="Accéder aux archives"
                    tabindex="7"
                    matTooltip="Accéder aux archives"
                    matTooltipPosition="below"
                    [disabled]="!view.archivingEnabled"
                    (click)="onSwitchBetweenArchivedAndLiveFoldersList()">
                    <fa-icon [icon]="archivedFoldersAccessIcon"></fa-icon>
                </button>
            </div>
        }
    }
    @if (foldersExportRight) {
        <button
            mat-fab
            class="basic-button small"
            aria-label="Exporter les dossiers"
            tabindex="8"
            matTooltip="Exporter les dossiers dans un fichier EXCEL"
            matTooltipPosition="below"
            (click)="onExport()">
            <fa-icon [icon]="exportIcon"></fa-icon>
        </button>
    }
</div>
